module.exports = __webpack_public_path__ + "static/modernizace-php-aplikaci-2-dbf1ab8cc1cc429392992b10966b88da.jpg";